import React, { useState } from "react";
import styles from "../Dashoard.module.css";
import SelectField from "../../SelectField/SelectField";
import Buttons from "../../Button/Button";
import { SettignIcon } from "../../../assets/icons/SettignIcon";
import { margin } from "@mui/system";


const SelectForm = (props) => {

  const {
    range,
    setRange
  } = props

  const [age, setAge] = React.useState('');
  const handleChanges = (event) => {
    setAge(event.target.value);
  };

  const options = [
    {
      label: "My week",
      value: "weekly",
    },

    {
      label: "My month",
      value: "monthly",
    },

  ]

  return (
    <div className={styles.SelectForm}>
      <div className={styles.SelectFormLeft}>
        <SelectField
          options={options}
          handleChange={(e) => setRange(e.target.value)}
          defaultValue={range}
        />
      </div>
      <div className={styles.SelectFormRight}>
        {/* <Buttons
          label="Customize"
          buttonColor="#fff"
          border="#E8EAED 1px solid"
          color="#33415C"
          height="36px"
          fontSize="14px"
          fontWeight="500"
          padding="0 8px"
          icon={<div style={{display:"flex", marginRight:"4px"}}><SettignIcon /></div>}
        /> */}
      </div>
    </div>
  );
};

export default SelectForm;
